module.exports = __webpack_public_path__ + "2ee2271c0685b647588e3e54fcb854d3.png";